import { computed } from 'vue';
import store from '@/store';
import { t } from '@/utils/i18n-helper'

export function usePresaleButtons(event) {
    const user = computed(() => store.getters.getUser);

    const ignorarRegistro = computed(() => event.value?.id === 19334);

    const ruta = computed(() => {
        return event.value.varias_sesiones
            ? 'front.eventos.sesiones'
            : 'front.eventos.show';
    });

    const registradoEnPreventa = computed(() => {
        if (ignorarRegistro.value) return false;

        return Boolean(
            user.value &&
            event.value.preventa?.registrado_en_preventa
        );
    });

    const mostrarVenta = computed(() => {
        if (!ignorarRegistro.value) {
            return Boolean(
                user.value &&
                event.value.preventa?.venta_preventa_activa
            );  
        }

        return Boolean(
            event.value.preventa?.venta_preventa_activa
        );
    });

    const desactivarVenta = computed(() => {
        if (ignorarRegistro.value) {
            return false;
        }

        const preventa = event.value.preventa;

        if (!preventa) return true;

        if (!user.value) return true;

        if (!preventa.registrado_en_preventa) return true;

        if (!preventa.puede_comprar_en_preventa) return true;

        if (preventa.comprado_en_preventa) return true;

        return false;
    });

    const desactivarPreventa = computed(() => {
        if (ignorarRegistro.value) return true;

        return Boolean(
            user.value &&
            (
                !event.value.preventa?.registro_preventa_activo ||
                event.value.preventa?.registrado_en_preventa
            )
        );
    });

    const mensaje = computed(() => {
        const preventa = event.value.preventa;
        if (!preventa || ignorarRegistro.value) return null;

        if (preventa.comprado_en_preventa) {
            return t('preventa.ha_comprado_preventa');
        }

        if (preventa.solicitud_denegada) {
            return null;
        }

        if (!user.value && preventa.venta_preventa_activa) {
            return t('preventa.debe_iniciar_sesion');
        }

        if (!preventa.registrado_en_preventa) {
            return t('preventa.no_registrado');
        }

        if (
            preventa.venta_preventa_activa &&
            !preventa.puede_comprar_en_preventa
        ) {
            return t('preventa.solicitud_en_revision');
        }

        return null;
    });

    return {
        ruta,
        registradoEnPreventa,
        mostrarVenta,
        desactivarVenta,
        desactivarPreventa,
        mensaje,
        user,
        ignorarRegistro
    };
}
